export default {
  namespaced: true,
  state: () => ({
    isBetaPopup: false,
    isCoinListPopup: false,
    isinquiryModal: false,
    isRefPopup: false,
    alertMsg: {
      visible: false,
      code: 0,
    },
    videoStatus:{
      visible:false,
      type:''
    }
  }),
  mutations: {
    openBetaPopup(state, val) {
      state.isBetaPopup = val;
    },
    openCoinListPopup(state, val) {
      state.isCoinListPopup = val;
    },
    toggleAlertMsg(state, payload) {
      state.alertMsg.visible = payload.visible;
      state.alertMsg.code = payload.code;
    },
    toggleVideo(state,val){
      state.videoStatus.visible = val.visible;
      state.videoStatus.type = val.type;
    },
    setRefPopup(state, val) {
      state.isRefPopup = val;
    }
  },
  actions: {
    openBetaPopup({ commit }, val) {
      // this.isBetaPopup = val;
      commit("openBetaPopup", val);
    },

    openCoinListPopup({ commit }, val) {
      // this.isBetaPopup = val;
      commit("openCoinListPopup", val);
    },

    openInquiryModal(val) {
      this.isinquiryModal = val;
    },
    setRefPopup({ commit }, val) {
      commit("setRefPopup", val);
    }
  },
  getters: {
    betaPopup(state) {
      return state.isBetaPopup;
    },
    coinListPopup(state) {
      return state.isCoinListPopup;
    },
    betaMenu(state) {
      return state.betaMenuKeys;
    },
    inquiryModal(state) {
      return state.isinquiryModal;
    },
    // getErrorText(state){

    // }
  },
};
